import React, { useEffect } from "react";

export default function GlobalTuitionDueDate({ Field, sessionStartDate, defaultValue = "", InputContext, onChange }) {
  const suggested = defaultValue || sessionStartDate || "";
  useEffect(() => { if (onChange) onChange(suggested); }, [suggested, onChange]);
  return <Field name="first_tuition_due_date" title="First Tuition Due Date" grow required
    defaultValue={suggested} InputContext={InputContext} onChange={onChange} />;
}
